"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceWithStar = exports.formatStrings = exports.byteArrayToString = exports.stringToByteArray = exports.getDir = exports.isEnglishNumber = exports.isPersianNumber = exports.hasPersianNumber = exports.hasEnglishChar = exports.hasPersianChar = exports.padZero = exports.lpad = exports.formatMoneyAmount = void 0;
exports.trimPrefix = trimPrefix;
exports.arrayBufferToBase64 = arrayBufferToBase64;
exports.isNumeric = isNumeric;
exports.countOccurrences = countOccurrences;
exports.countLinks = countLinks;
function trimPrefix(text, prefix) {
    const regex = new RegExp(`^${prefix}`);
    return text.replace(regex, "");
}
const irMoneyFormat = new Intl.NumberFormat("fa-IR");
const formatMoneyAmount = (number) => irMoneyFormat.format(typeof number === "string" ? Number(number) : number);
exports.formatMoneyAmount = formatMoneyAmount;
const lpad = (str, padStr, length) => {
    while (str.length < length)
        str = padStr + str;
    return str;
};
exports.lpad = lpad;
const padZero = (number, length) => {
    return (0, exports.lpad)(number.toString(), "0", length);
};
exports.padZero = padZero;
const hasPersianChar = (text) => {
    return /[\u0600-\u06ef]/g.test(text);
};
exports.hasPersianChar = hasPersianChar;
const hasEnglishChar = (text) => {
    return /[a-zA-Z0-9]/g.test(text);
};
exports.hasEnglishChar = hasEnglishChar;
const hasPersianNumber = (text) => {
    return /[\u06F0-\u06F9]/g.test(text);
};
exports.hasPersianNumber = hasPersianNumber;
const isPersianNumber = (text) => {
    return text.match(/^[۰-۹]+$/) != null;
};
exports.isPersianNumber = isPersianNumber;
const isEnglishNumber = (text) => {
    return text.match(/^[0-9]+$/) != null;
};
exports.isEnglishNumber = isEnglishNumber;
const getDir = (text) => (0, exports.hasPersianChar)(text) ? "rtl" : "ltr";
exports.getDir = getDir;
const encoder = new TextEncoder();
const decoder = new TextDecoder();
const stringToByteArray = (text) => encoder.encode(text);
exports.stringToByteArray = stringToByteArray;
const byteArrayToString = (text) => decoder.decode(text);
exports.byteArrayToString = byteArrayToString;
function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}
// isNumeric https://stackoverflow.com/questions/175739/how-can-i-check-if-a-string-is-a-valid-number
function isNumeric(str) {
    if (typeof str != "string")
        return false;
    return (!isNaN(Number(str)) &&
        !isNaN(parseFloat(str)) /* for empty string parsing */);
}
const formatStrings = (template, data) => {
    var _a;
    return ((_a = (template !== null && template !== void 0 ? template : "").replace(/{(\w+)}/g, (_, key) => {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data[key]) !== null && _a !== void 0 ? _a : "";
    })) !== null && _a !== void 0 ? _a : "");
};
exports.formatStrings = formatStrings;
function countOccurrences(string, subString) {
    let count = 0;
    let index = 0;
    while ((index = string.indexOf(subString, index)) !== -1) {
        count++;
        index++;
    }
    return count;
}
function countLinks(str) {
    const urlRegex = /\b(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+|\b(?:\d{1,3}\.){3}\d{1,3}\b)(?:\/[^\s]*)?\b/g;
    const matches = str.match(urlRegex);
    return matches ? matches.length : 0;
}
// useful for card numbers
// 1231 2133 2314 3243 -> 1231 **** **** 3243
const replaceWithStar = (text, startIndex, endIndex) => {
    var _a;
    return (_a = (text.substring(0, startIndex) +
        "*".repeat(endIndex - startIndex + 1) +
        text.substring(endIndex + 1))
        .match(/.{1,4}/g)) === null || _a === void 0 ? void 0 : _a.join(" ");
};
exports.replaceWithStar = replaceWithStar;
//# sourceMappingURL=strings.js.map